import useFormatMessage from 'hooks/useFormatMessage';
import messages from './messages';

const PrivacySettingLabel = ({ value }) => {
  const $t = useFormatMessage();
  return messages[value] ? $t(messages[value]) : null;
};

export default PrivacySettingLabel;
